// Maps Swedish DB-stored pricing strings to i18n keys under `pricingDb.*`.
// Keep in sync with pricing_plans/pricing_addons rows.
export const PRICING_DB_TRANSLATION_MAP: Record<string, string> = {
  // Valid features
  "Validering av adresser i hela Norden": "pricingDb.nordicValidation",
  "Autocomplete för gatunamn, postnummer och postorter": "pricingDb.autocomplete",
  "Kontroll av län, kommun, församling och distrikt": "pricingDb.adminControl",
  // Atlas features
  "12 månaders bindningstid": "pricingDb.bindingTime12",
  "1 admin, 1 karta, 1 land": "pricingDb.oneAdminMapCountry",
  "Importera egen data på karta": "pricingDb.importOwnData",
  "Skapa, visa och hantera områden": "pricingDb.createManageAreas",
  "Integrera till dina system via API": "pricingDb.integrateApi",
  "Exportera 2 000 postnummer/mån": "pricingDb.export2000Postal",
  "Exportera obegränsat med postnummer": "pricingDb.exportUnlimitedPostal",
  "Routing Small inkluderat": "pricingDb.routingSmallIncluded",
  // Valid detail labels
  "Valideringar/mån": "pricingDb.validationsPerMonth",
  "Autocomplete/mån": "pricingDb.autocompletePerMonth",
  "Överskjutande validering": "pricingDb.extraValidation",
  "Överskjutande autocomplete": "pricingDb.extraAutocomplete",
  // Valid addons
  "Geokodning adress": "pricingDb.geocodeAddress",
  "Geokodning postnummer": "pricingDb.geocodePostal",
  "Fastighetsbeteckning": "pricingDb.propertyDesignation",
  "UUID": "pricingDb.uuid",
  "DeSO/RegSO": "pricingDb.desoRegso",
  // Atlas addons
  "Extra land": "pricingDb.extraCountry",
  "Extra karta": "pricingDb.extraMap",
  "Extra admin": "pricingDb.extraAdmin",
  "Extra titt-användare": "pricingDb.extraViewer",
  "Export postnummer": "pricingDb.exportPostal",
  "Export koordinater": "pricingDb.exportCoordinates",
  // Common values
  "Enligt offert": "pricingDb.perQuote",
  "Ingår": "pricingDb.included",
};

export function translatePricingString(
  value: string,
  t: (key: string) => string
): string {
  const key = PRICING_DB_TRANSLATION_MAP[value];
  if (!key) return value;
  const translated = t(key);
  return translated === key ? value : translated;
}
